import React from 'react';
import NewTabLink from '@sls-react/components/Links/NewTabLink';

const socialLinks = {
  baseballInstagram: 'https://www.instagram.com/sidelineswap.baseball/',
  facebook: 'https://www.facebook.com/SidelineSwap',
  hockeyInstagram: 'https://www.instagram.com/sidelineswap.hockey/',
  hockeyYouTube: 'https://www.youtube.com/channel/UCLpHsLshqKjie46hcv7j25w',
  instagram: 'https://www.instagram.com/sidelineswap/',
  youtube: 'https://www.youtube.com/channel/UCwTgtTvQ8VdQ16-MnwU_Khg',
  twitter: 'https://www.twitter.com/sidelineswap',
};

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  link: keyof typeof socialLinks;
};

const SocialLink: React.FC<Props> = ({ children, link, ...props }) => (
  <NewTabLink {...props} href={socialLinks[link]}>
    {children}
  </NewTabLink>
);

export default SocialLink;
